<template>
  <div v-if="hasRetentionInfo" class="retention-info">
    <span class="text-body-2 font-italic">
      {{ $t('routes.recycleBin.deletedDueToRetentionPolicy') }} {{ formatRetentionMessage }}
    </span>
  </div>
</template>

<script>
import { format, addHours, addDays, addWeeks, addMonths } from 'date-fns';

export default {
  name: 'RecycleBinRetentionPeriod',
  props: {
    pod: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasRetentionInfo() {
      return this.pod?.retention && this.pod.retention.startedAt && this.pod.retention.period && this.pod.retention.periodType;
    },

    retentionStartDate() {
      if (!this.pod?.retention?.startedAt) return null;
      return new Date(this.pod.retention.startedAt);
    },

    retentionPeriod() {
      return this.pod?.retention?.period || 0;
    },

    retentionPeriodType() {
      return this.pod?.retention?.periodType || 'HOURS';
    },

    formatRetentionMessage() {
      if (!this.hasRetentionInfo) return '';

      const period = this.retentionPeriod;
      const type = this.retentionPeriodType.toLowerCase();
      const startDate = format(this.retentionStartDate, 'MMM dd, yyyy HH:mm');

      const periodText = this.$t(`common.time.${type}`, period);

      return `(${periodText} ${this.$t('routes.recycleBin.retentionPeriod')} - ${this.$t('routes.recycleBin.startedOn')} ${startDate})`;
    },

    expirationDate() {
      if (!this.hasRetentionInfo) return null;

      const startDate = this.retentionStartDate;
      const period = this.retentionPeriod;
      const type = this.retentionPeriodType;

      switch (type) {
        case 'HOURS':
          return addHours(startDate, period);
        case 'DAYS':
          return addDays(startDate, period);
        case 'WEEKS':
          return addWeeks(startDate, period);
        case 'MONTHS':
          return addMonths(startDate, period);
        default:
          return addHours(startDate, period);
      }
    },
  },
};
</script>

<style scoped>
.retention-info {
  font-size: 0.875rem;
}
</style>
